/**
 * @file  accessibility.ts
 * @description  plug-in for accessibility features. This is enabled for each deployment
 *               To disable, do not set the REACT_APP_ACCESSIBILITY on the enviroment file
 *
 * @author ogarcia (ozkary)
 * @date 02032022
 */

/**
 * configure the site key on the env file. Make sure update the env file for the deployment step
 * Each site as a key
 */
const accessibilityKey = process.env.REACT_APP_ACCESSIBILITY;

/**
 * call to bootstrap the widget on the body of the document
 * enable the
 * @returns void
 */
const accessibility = (): void => {
  if (!accessibilityKey) {
    return;
  }

  // define the dynamic properties to support the widget
  interface Window {
    interdeal: Record<string, unknown>;
  }

  const w = (window as unknown) as Window;

  /**
   * initialize the widget with the corresponding deployment key
   */
  w.interdeal = {
    sitekey: accessibilityKey,
    Position: 'Left',
    Menulang: 'EN',
    domains: {
      js: 'https://cdn.equalweb.com/',
      acc: 'https://access.equalweb.com/'
    },
    btnStyle: {
      vPosition: ['80%', null],
      scale: ['0.8', '0.8'],
      color: { main: '#00539b', second: '#fff' },
      icon: {
        type: 7,
        shape: 'semicircle',
        outline: false
      }
    }
  };

  /**
   * bootstrap the widget to the document
   */
  const coreCall = document.createElement('script');
  coreCall.src = 'https://cdn.equalweb.com/core/4.0.4/accessibility.js';
  coreCall.defer = true;
  coreCall.integrity =
    'sha512-LDvqiv8qYdF1MIqxiGZrvcDsmN6cZy0u0l23Dj7TVXmkVSNyzjtkcll8uCb8EGdwDVHjvisVYsAWuwTf6Mpu8g==';
  coreCall.crossOrigin = 'anonymous';
  coreCall.setAttribute('data-cfasync', 'true');
  document.body.appendChild(coreCall);
};

/**
 * export the boot strappping function
 * @usage accessibility()
 */
export default accessibility;
